/* ==========================================================================
   dfy-theme.js

   Tiroirs, accordéons, onglets, galerie, recherche prédictive, ajout rapide,
   panier, sélecteur de variante, bascule d'unités, densité de grille.

   Aucune dépendance. Tous les écouteurs sont délégués sur document, donc un
   fragment injecté après coup fonctionne sans réinitialisation. Les seules
   initialisations par élément sont marquées d'un drapeau pour rester
   idempotentes après un rendu de section.
   ========================================================================== */
(function () {
  'use strict';

  var body = document.body;
  var cfg = window.dfy || {};

  function once(el, key) {
    if (el.dataset[key] === '1') return false;
    el.dataset[key] = '1';
    return true;
  }

  function money(cents) {
    var f = cfg.moneyFormat || '{{amount}}';
    var n = (cents / 100).toFixed(2);
    if (f.indexOf('comma_separator') > -1) n = n.replace('.', ',');
    return f.replace(/\{\{\s*\w+\s*\}\}/, n);
  }

  /* Un échec doit parler. Sans cette trace, une requête ratée disparaissait
     sans laisser d'indice : ni message, ni console, ni comportement visible. */
  function fail(where, err) {
    if (window.console) console.warn('[dfy] ' + where, err);
  }

  /* ================================================================ tiroirs */

  var scrim = document.querySelector('[data-dfy-scrim]');
  var current = null;
  var restoreFocus = null;

  /* Les tiroirs doivent sortir de la section collante : à l'intérieur, le
     contexte d'empilement créé par le header enferme position:fixed et le
     tiroir se cale sur la section au lieu du viewport. */
  function relocate() {
    document.querySelectorAll('[data-dfy-drawer]').forEach(function (d) {
      if (d.parentElement !== body) body.appendChild(d);
    });
  }

  function open(id) {
    var d = document.getElementById(id);
    if (!d) { fail('tiroir absent du DOM', id); return; }
    restoreFocus = document.activeElement;
    closeAll(true);
    d.hidden = false;
    void d.offsetWidth;              // repart de l'état fermé
    d.classList.add('is-open');
    if (scrim) {
      scrim.hidden = false;
      void scrim.offsetWidth;
      scrim.classList.add('is-on');
    }
    body.classList.add('dfy-lock');
    current = d;
    var first = d.querySelector('input:not([type="hidden"]), button, a[href]');
    if (first) first.focus({ preventScroll: true });
  }

  function closeAll(silent) {
    document.querySelectorAll('[data-dfy-drawer].is-open').forEach(function (d) {
      d.classList.remove('is-open');
      window.setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 340);
    });
    if (scrim) {
      scrim.classList.remove('is-on');
      window.setTimeout(function () { if (!scrim.classList.contains('is-on')) scrim.hidden = true; }, 340);
    }
    body.classList.remove('dfy-lock');
    current = null;
    if (!silent && restoreFocus) { restoreFocus.focus(); restoreFocus = null; }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-dfy-open]');
    if (opener) { e.preventDefault(); open(opener.dataset.dfyOpen); return; }
    if (e.target.closest('[data-dfy-close]') || e.target.closest('[data-dfy-scrim]')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !current) return;
    closeAll();
  });

  /* Piège de focus : sans lui, la tabulation sort du tiroir et parcourt la
     page masquée derrière le voile. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !current) return;
    var f = current.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ============================================================= accordéons */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dfy-acc]');
    if (!btn) return;
    var panel = btn.nextElementSibling;
    if (!panel) return;
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!isOpen));

    if (isOpen) {
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () { panel.style.height = '0px'; });
    } else {
      panel.style.height = panel.scrollHeight + 'px';
      panel.addEventListener('transitionend', function done(ev) {
        if (ev.propertyName !== 'height') return;
        // auto pour que le contenu puisse encore grandir (images tardives)
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', done);
      });
    }
  });

  /* ============================================ panneaux bascule et onglets */

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-dfy-toggle]');
    if (!t) return;
    var panel = document.getElementById(t.dataset.dfyToggle);
    if (!panel) return;
    var isOpen = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
  });

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-dfy-tab]');
    if (!tab) return;
    var scope = tab.closest('[data-dfy-drawer]') || tab.closest('section') || document;
    var id = tab.dataset.dfyTab;
    scope.querySelectorAll('[data-dfy-tab]').forEach(function (b) {
      var on = b.dataset.dfyTab === id;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', String(on));
    });
    scope.querySelectorAll('[data-dfy-pane]').forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.dfyPane === id);
    });
  });

  /* =================================================== bascule cm / pouces */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dfy-unit]');
    if (!btn) return;
    var root = btn.closest('[data-dfy-model]');
    if (!root) return;
    var unit = btn.dataset.dfyUnit;
    root.dataset.unit = unit;
    root.querySelectorAll('[data-dfy-unit]').forEach(function (b) {
      var on = b.dataset.dfyUnit === unit;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
    });
    /* On échange le texte pré-calculé plutôt que de convertir : une conversion
       en JS arrondirait différemment de la fiche technique. */
    root.querySelectorAll('[data-dfy-value]').forEach(function (v) {
      var next = v.dataset[unit];
      if (next) v.textContent = next;
    });
  });

  /* ============================================== densité de grille mobile */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dfy-density]');
    if (!btn) return;
    var scope = btn.closest('[data-dfy-collection]') || document;
    var grid = scope.querySelector('[data-dfy-grid]');
    if (!grid) return;
    grid.dataset.colsMobile = btn.dataset.dfyDensity;
    scope.querySelectorAll('[data-dfy-density]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
    });
  });

  /* ================================================= pastilles couleur « … » */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-dfy-dots-more]');
    var pop = document.querySelector('[data-dfy-dots-pop]:not([hidden])');

    if (trigger) {
      var own = trigger.parentElement.querySelector('[data-dfy-dots-pop]');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      // referme toute autre liste avant d'ouvrir celle-ci
      document.querySelectorAll('[data-dfy-dots-pop]').forEach(function (p) { p.hidden = true; });
      document.querySelectorAll('[data-dfy-dots-more]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (!isOpen && own) { own.hidden = false; trigger.setAttribute('aria-expanded', 'true'); }
      return;
    }

    // clic hors de la liste : on referme
    if (pop && !e.target.closest('[data-dfy-dots-pop]')) {
      pop.hidden = true;
      document.querySelectorAll('[data-dfy-dots-more]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var pop = document.querySelector('[data-dfy-dots-pop]:not([hidden])');
    if (!pop) return;
    pop.hidden = true;
    var btn = pop.parentElement.querySelector('[data-dfy-dots-more]');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
  });

  /* ========================================================== tri collection */

  /* Le tri vit dans le tiroir, en boutons radio. Un changement recharge la
     page : Shopify calcule le tri côté serveur, il n'y a rien à réordonner
     en JS et le rendu resterait divergent d'un rechargement complet. */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-dfy-sort]');
    if (!input) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', input.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* Les facettes s'appliquent au changement, sans bouton, sauf en tiroir où le
     bouton évite un rechargement par case cochée. */
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-dfy-sort]')) return;
    var form = e.target.closest('.dfy-filters');
    if (!form || form.id === 'Filters-mob') return;
    var params = new URLSearchParams(new FormData(form));
    window.location.href = window.location.pathname + '?' + params.toString();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#Filters-mob');
    if (!form) return;
    e.preventDefault();
    var params = new URLSearchParams(new FormData(form));
    window.location.href = window.location.pathname + '?' + params.toString();
  });

  /* ==================================================== recherche prédictive */

  var searchTimer = null;

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-dfy-search]');
    if (!input) return;
    var out = document.querySelector('[data-dfy-search-out]');
    if (!out) return;

    window.clearTimeout(searchTimer);
    var q = input.value.trim();
    if (q.length < 2) return;

    searchTimer = window.setTimeout(function () {
      var url = cfg.routes.predictive_search_url +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8' +
        '&section_id=dfy-predictive';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var frag = doc.querySelector('[data-dfy-predictive]');
          if (frag) out.innerHTML = frag.innerHTML;
        })
        .catch(function () { /* le champ reste utilisable, la soumission marche */ });
    }, 250);
  });

  /* ================================================================= panier

     Noms de section interrogés pour re-rendre le tiroir, dans l'ordre. Le
     premier qui renvoie un #CartDrawer est retenu et mémorisé : inutile de
     tâtonner deux fois par session.

     C'est ici que se jouait la panne. La version précédente n'essayait que
     « dfy-cart-drawer-host ». Ce nom doit correspondre à un fichier réel de
     sections/ ; s'il n'existe pas, ou si le tiroir est un snippet rendu
     ailleurs, la requête ne renvoie jamais de tiroir — et comme l'ouverture
     était enchaînée derrière, l'article partait au panier sans que rien ne
     bouge à l'écran. */
  var CART_SECTIONS = ['dfy-cart-drawer-host', 'dfy-cart-drawer', 'cart-drawer'];
  var cartSection = null;

  /* Les routes exposées par le thème — routes.cart_add_url, cart_change_url —
     valent /cart/add et /cart/change. Ce sont les adresses de l'attribut
     action d'un formulaire HTML : elles répondent par une page entière, et
     r.json() échouait sur « Unexpected token < ».

     L'API AJAX du panier vit sur les mêmes chemins suffixés de .js. Le suffixe
     n'est pas décoratif, c'est lui qui choisit le format de réponse. On le
     pose ici plutôt que dans theme.liquid pour que les routes restent utiles
     à un formulaire sans JavaScript.

     Le préfixe de langue est conservé : /fr/cart/add devient /fr/cart/add.js. */
  function jsRoute(url, repli) {
    var u = url || repli;
    if (/\.js($|\?)/.test(u)) return u;
    return u.replace(/\/$/, '') + '.js';
  }

  /* On analyse le corps, jamais l'en-tête. Shopify répond tantôt
     application/json, tantôt text/javascript sur ces adresses : se fier au
     Content-Type faisait échouer un ajout parfaitement réussi.

     Un corps qui commence par « < » est une page HTML, donc une route de
     panier sans le suffixe .js — la seule erreur qui mérite d'être nommée.
     Un 422 porte, lui, une description exploitable : variante épuisée, stock
     insuffisant. On la remonte telle quelle. */
  function lireJson(r, url) {
    return r.text().then(function (txt) {
      var json;
      try {
        json = JSON.parse(txt);
      } catch (e) {
        if (txt.trim().charAt(0) === '<') {
          throw new Error('Page HTML reçue de ' + url + ' — suffixe .js manquant sur la route');
        }
        throw new Error('Réponse illisible de ' + url + ' (' + r.status + ')');
      }
      if (!r.ok) throw new Error(json.description || json.message || 'cart');
      return json;
    });
  }

  var CART_ADD = jsRoute(cfg.routes && cfg.routes.cart_add_url, '/cart/add');
  var CART_CHANGE = jsRoute(cfg.routes && cfg.routes.cart_change_url, '/cart/change');
  var CART_GET = jsRoute(cfg.routes && cfg.routes.cart, '/cart');

  function fetchDrawer(name) {
    return fetch(window.location.pathname + '?section_id=' + name)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.getElementById('CartDrawer');
      })
      .catch(function () { return null; });
  }

  function swapDrawer(fresh) {
    var now = document.getElementById('CartDrawer');
    if (!fresh || !now) return;
    var wasOpen = now.classList.contains('is-open');
    now.replaceWith(fresh);
    body.appendChild(fresh);
    if (wasOpen) { fresh.hidden = false; fresh.classList.add('is-open'); }
  }

  function updateCount() {
    return fetch(CART_GET)
      .then(function (r) { return lireJson(r, CART_GET); })
      .then(function (cart) {
        document.querySelectorAll('[data-dfy-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function (e) { fail('compteur panier', e); });
  }

  /* Ne rejette jamais. Le rafraîchissement est un confort : s'il échoue, le
     tiroir doit quand même s'ouvrir, avec son contenu précédent. */
  function refreshCart() {
    var noms = cartSection ? [cartSection] : CART_SECTIONS;
    var chaine = Promise.resolve(null);

    noms.forEach(function (nom) {
      chaine = chaine.then(function (found) {
        if (found) return found;
        return fetchDrawer(nom).then(function (el) {
          if (el) cartSection = nom;
          return el;
        });
      });
    });

    return chaine
      .then(function (fresh) {
        if (!fresh) fail('tiroir introuvable, vérifier le nom de section', CART_SECTIONS.join(', '));
        else swapDrawer(fresh);
        return updateCount();
      })
      .catch(function (e) { fail('rafraîchissement panier', e); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dfy-qty]');
    if (!btn) return;
    var line = btn.closest('[data-dfy-line]');
    if (!line) return;

    var action = btn.dataset.dfyQty;
    var now = parseInt(line.querySelector('.dfy-qty__v').textContent, 10) || 0;
    var next = action === 'remove' ? 0 : now + parseInt(action, 10);
    if (next < 0) next = 0;

    line.style.opacity = '.5';
    fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line.dataset.dfyLine, 10), quantity: next })
    })
      .then(function () { return refreshCart(); })
      .catch(function (err) {
        line.style.opacity = '';
        fail('modification de ligne', err);
      });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-dfy-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[data-dfy-submit]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    if (btn) btn.setAttribute('aria-disabled', 'true');

    var msg = form.querySelector('[data-dfy-error]');
    if (msg) msg.hidden = true;

    var data = new FormData(form);
    var qty = parseInt(data.get('quantity'), 10) || 1;

    fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: data.get('id'), quantity: qty }] })
    })
      .then(function (r) { return lireJson(r, CART_ADD); })
      .then(function () {
        // Le tiroir s'ouvre d'abord, le rafraîchissement suit.
        open('CartDrawer');
        return refreshCart();
      })
      .catch(function (err) {
        if (msg) { msg.textContent = err.message || cfg.strings.cartError; msg.hidden = false; }
        fail('ajout au panier', err);
      })
      .finally(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  });

  /* =========================================================== ajout rapide */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dfy-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var out = document.querySelector('[data-dfy-quick-out]');
    if (!out) return;
    out.innerHTML = '';
    open('QuickAdd');

    fetch('/products/' + btn.dataset.handle + '?section_id=dfy-quick-add')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var frag = doc.querySelector('[data-dfy-quick]');
        if (frag) out.appendChild(frag);
        else fail('panneau d\'ajout rapide vide', btn.dataset.handle);
      })
      .catch(function (err) { fail('ajout rapide', err); });
  });

  /* ==================================================== sélecteur de variante */

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-dfy-option]');
    if (!input) return;
    var root = input.closest('[data-dfy-product]');
    if (!root) return;

    var store = root.querySelector('[data-dfy-variants]');
    if (!store) return;
    var variants = JSON.parse(store.textContent);

    var chosen = Array.prototype.map.call(
      root.querySelectorAll('[data-dfy-option]:checked'),
      function (i) { return i.value; }
    );

    // reflète le choix dans la légende
    root.querySelectorAll('[data-dfy-opt-value]').forEach(function (span) {
      var pos = parseInt(span.dataset.dfyOptValue, 10);
      if (chosen[pos - 1]) span.textContent = chosen[pos - 1];
    });

    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });

    var btn = root.querySelector('[data-dfy-submit]');
    var idInput = root.querySelector('[data-dfy-id]');
    var priceHost = root.querySelector('[data-dfy-price]');

    if (!match) {
      if (btn) { btn.textContent = cfg.strings.unavailable; btn.setAttribute('aria-disabled', 'true'); }
      return;
    }

    if (idInput) idInput.value = match.id;

    if (btn) {
      btn.textContent = match.available ? cfg.strings.addToCart : cfg.strings.soldOut;
      if (match.available) btn.removeAttribute('aria-disabled');
      else btn.setAttribute('aria-disabled', 'true');
    }

    if (priceHost) {
      var html = '<span class="dfy-price__now">' + money(match.price) + '</span>';
      if (match.compare_at_price > match.price) {
        var off = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
        html = '<span class="dfy-price__was">' + money(match.compare_at_price) + '</span>' + html +
               '<span class="dfy-price__off">-' + off + '\u00A0%</span>';
      }
      priceHost.innerHTML = html;
    }

    if (root.dataset.section) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
  });

  /* ================================================================ galerie */

  function initGallery(rail) {
    if (!once(rail, 'dfyGal')) return;
    var bars = rail.parentElement.querySelectorAll('.dfy-pdp__prog-bar');
    if (!bars.length) return;
    var slides = Array.prototype.slice.call(rail.children);

    /* Observation du rail plutôt qu'écoute du scroll : l'observateur ne se
       déclenche qu'au franchissement du seuil, là où un écouteur de scroll
       recalculerait à chaque image et ferait travailler le fil principal
       pendant tout le geste. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 0.6) return;
        var i = slides.indexOf(entry.target);
        bars.forEach(function (b, j) { b.classList.toggle('is-on', j === i); });
      });
    }, { root: rail, threshold: 0.6 });

    slides.forEach(function (s) { io.observe(s); });
  }

  /* ================================================================== avis */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dfy-more]');
    if (!btn) return;
    var list = document.querySelector('[data-dfy-reviews]');
    if (!list) return;
    var hidden = list.querySelectorAll('.is-hidden');
    // trois par trois : la page ne saute pas et le bouton reste à portée
    Array.prototype.slice.call(hidden, 0, 6).forEach(function (li) { li.classList.remove('is-hidden'); });
    if (!list.querySelector('.is-hidden')) btn.hidden = true;
  });

  /* ============================================================ init légère */

  function init() {
    relocate();
    document.querySelectorAll('[data-dfy-gallery]').forEach(initGallery);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', init);
})();
